import { mapActions } from 'vuex';
import constants from '@/constants';
import { isDebugOn } from '@/logger';

const appNotificationMixin = {
  props: {
    autoClose: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeTimeout: {
      type: Number,
      required: false,
      default: constants.DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
    },
    index: {
      type: Number,
      required: true,
    },
    closeButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      timeout: null,
      interacted: false,
    };
  },
  methods: {
    ...mapActions('notifications', ['remove']),
    onClose() {
      this.remove(this.index);
    },
    onInteract() {
      this.interacted = true;
    },
  },
  computed: {
    isDebug() {
      return isDebugOn();
    },
    showAutoCloseLoader() {
      return this.autoClose && this.closeTimeout > 0 && !this.interacted && !this.isDebug;
    },
  },
  mounted() {
    this.$el.addEventListener('click', () => this.onInteract());
    if (this.autoClose && !this.isDebug) {
      this.timeout = setTimeout(() => {
        if (!this.interacted) this.onClose();
      }, this.closeTimeout);
    }
  },
  beforeUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.onClose();
  },
};

export default appNotificationMixin;
